import { render, staticRenderFns } from "./OrganizationChartContainer.vue?vue&type=template&id=67db2d60"
import script from "./OrganizationChartContainer.vue?vue&type=script&lang=js"
export * from "./OrganizationChartContainer.vue?vue&type=script&lang=js"
import style0 from "./OrganizationChartContainer.vue?vue&type=style&index=0&id=67db2d60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports